import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SEO = ({ data }) => {
	const metaTitle = data.meta_title[0]?.text;
	const metaDescription = data.meta_description[0]?.text;
	const metaTags = data.meta_keywords[0]?.text;

	return (
		<Helmet>
			<title>{metaTitle}</title>
			<meta charSet='utf-8' />
			<meta name='description' content={metaDescription} />
			<meta name='keywords' content={metaTags} />
			<script
				async
				defer
				src='https://static.cdn.prismic.io/prismic.js?new=true&repo=milligram'
			></script>
		</Helmet>
	);
};
